const columns = [
  {
    title: '处理详情',
    dataIndex: 'dealDetail',
    key: 'dealDetail'
  },
  {
    title: '痕迹/触达要求',
    dataIndex: 'traceOrReachRule',
    key: 'traceOrReachRule',
    slots: { customRender: 'traceOrReachRule' }
  },
  {
    title: '凭证',
    dataIndex: 'workOrderQualityProof',
    key: 'workOrderQualityProof',
    slots: { customRender: 'workOrderQualityProof' }
  },
  {
    title: '工作要求',
    dataIndex: 'supplementExplanation',
    key: 'supplementExplanation',
    slots: { customRender: 'supplementExplanation' }
  }
]

export { columns }
